import { getFromWeb } from "./http-instance";

export default class ContextService {
  static getUserContext() {
    return getFromWeb("/Context/GetUserContext");
  }
}
